import React, {ChangeEvent} from 'react';

import {RemoveEventFamily} from 'src/components/remove-event-family/remove-event-family';
import {Separator} from 'src/components/separator';
import {UserName} from 'src/components/user-name/user-name';
import {FamilyColumnTypes, FamilyColumnWidth} from 'src/modules/admin/constants';
import {EventFamilyInfo} from 'src/openapi/models/EventFamilyInfo';

import {Button} from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {Input} from '@pb/kit-component-input-v2';
import {
    HorizontalPositionElement,
    PushNotification,
    VerticalPositionElement,
} from '@pb/kit-component-push-notification';
import Table, {Body, Cell, Head, Row} from '@pb/kit-component-table';
import {Typography} from '@pb/kit-component-typography';
import {formatDate} from '@pb/kit-formatters';

type Props = {
    newFamily: string,
    families: EventFamilyInfo[],
    onSave: () => void,
    setNewFamily: (name: string) => void,
    onRemoveError: (message?: string) => void,
};

const MAX_EVENT_FAMILY_LENGTH = 40;
const NOTIFICATION_CONFIG = {
    horizontal: HorizontalPositionElement.RIGHT,
    vertical: VerticalPositionElement.BOTTOM,
};

export const EventFamiliesView = (props: Props) => {
    const {
        newFamily,
        families,
        onSave,
        setNewFamily,
        onRemoveError,
    } = props;

    const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setNewFamily(event.target.value.toUpperCase());
    };

    const onSaveHandler = () => {
        onSave();
    };

    const familyExists = families.some(family => family.name === newFamily);

    return (
        <Group direction="v" style={{width: '50%'}} className="pt-xxl">
            <Typography variant="heading-level-5">
                <strong>
                    Event Family Management
                </strong>
            </Typography>
            <Separator/>
            <Group direction="v" style={{width: '50%'}}>
                <Group direction="v" gap="m">
                    <Item><strong>New Family</strong></Item>
                    <Group>
                        <Item style={{width: '100%'}}>
                            <Input
                                maxLength={MAX_EVENT_FAMILY_LENGTH}
                                value={newFamily}
                                onChange={onChangeHandler}
                            />
                        </Item>
                        <Button
                            disabled={!newFamily || familyExists}
                            onClick={onSaveHandler}
                            variant="Type.SECONDARY">
                            Save
                        </Button>
                    </Group>
                </Group>
            </Group>
            <Table>
                <Head>
                    <Cell width={FamilyColumnWidth[FamilyColumnTypes.FAMILY]}>Name</Cell>
                    <Cell width={FamilyColumnWidth[FamilyColumnTypes.CREATION_DATE]}>Creation Date</Cell>
                    <Cell width={FamilyColumnWidth[FamilyColumnTypes.AUTHOR]}>Author</Cell>
                    <Cell width="1rem"/>
                </Head>
                <Body>
                    {families.map(family => (
                        <Row key={family.name}>
                            <Cell>{family.name}</Cell>
                            <Cell>{formatDate(family.createdAt)}</Cell>
                            <Cell><UserName email={family.createdBy}/></Cell>
                            <Cell verticalAlign="middle" className="text-align_center">
                                <PushNotification anchorOrigin={NOTIFICATION_CONFIG}>
                                    <RemoveEventFamily name={family.name} onError={onRemoveError}/>
                                </PushNotification>
                            </Cell>
                        </Row>
                    ))}
                </Body>
            </Table>
        </Group>
    );
};
